import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "pc_token";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const apply = useCallback((tk) => {
    if (tk) {
      localStorage.setItem(TOKEN_KEY, tk);
      axios.defaults.headers.common.Authorization = `Bearer ${tk}`;
    } else {
      localStorage.removeItem(TOKEN_KEY);
      delete axios.defaults.headers.common.Authorization;
    }
    setToken(tk || "");
  }, []);

  useEffect(() => {
    if (!token) { setReady(true); return; }
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    axios.get(`${API}/auth/me`)
      .then((r) => setUser(r.data.user))
      .catch(() => apply(""))
      .finally(() => setReady(true));
  }, []); // eslint-disable-line

  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    apply(data.token); setUser(data.user); return data.user;
  };
  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    apply(data.token); setUser(data.user); return data.user;
  };
  const logout = () => { apply(""); setUser(null); };
  const track = (event, meta) => { if (token) axios.post(`${API}/track`, { event, meta }).catch(() => {}); };

  return (
    <AuthContext.Provider value={{ token, user, ready, register, login, logout, track, setUser, authOpen, setAuthOpen, openAuth: () => setAuthOpen(true) }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
